import { createSlice } from "@reduxjs/toolkit";

export const messagesSlice = createSlice({
    name: "messages",
    initialState: {
        messages: [],
        rateMessageData: [],
        expiredAt: null,
        expiredScheduler: null,
        position: 0,
        isEmptyInput: true,
        isEnd: false,
        lastMessagePosition: null,
        loadingReply: false,
        messageLimit: false,
        messagesArchived: [],
        refresher: null,
        isqrLoading: false,
    },
    reducers: {
        setRateMessageData: (state, action) => {
            state.rateMessageData = action.payload;
        },
        setMessages: (state, action) => {
            state.messages = action.payload;
        },
        concatMessage: (state, action) => {
            state.messages = state.messages.concat(action.payload);
        },
        updateExpiredAt: (state) => {
            state.expiredAt = new Date().getTime() + 4 * 60000;
        },
        setExpiredScheduler: (state, action) => {
            state.expiredScheduler = action.payload;
        },
        incrementPosition: (state) => {
            state.position += 1;
        },
        setIsEmptyInput: (state, action) => {
            state.isEmptyInput = action.payload;
        },
        setIsEnd: (state, action) => {
            state.isEnd = action.payload;
        },
        setLastMessagePosition: (state, action) => {
            state.lastMessagePosition = action.payload;
        },
        setLoadingReply: (state, action) => {
            state.loadingReply = action.payload;
        },
        setMessageLimit: (state, action) => {
            state.messageLimit = action.payload;
        },
        setMessagesArchived: (state, action) => {
            state.messagesArchived = action.payload;
        },
        setRefresher: (state, action) => {
            state.refresher = action.payload;
        },
        clearRefresher: (state) => {
            clearInterval(state.refresher), (state.refresher = null);
        },
        setIsqrLoading: (state, action) => {
            state.isqrLoading = action.payload;
        },
    },
});

export const {
    concatMessage,
    setRateMessageData,
    setMessages,
    updateExpiredAt,
    setExpiredScheduler,
    incrementPosition,
    setIsEmptyInput,
    setIsEnd,
    setLastMessagePosition,
    setLoadingReply,
    setMessageLimit,
    setMessagesArchived,
    setRefresher,
    clearRefresher,
    setIsqrLoading,
} = messagesSlice.actions;

export default messagesSlice.reducer;
